var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ButtonSelect',_vm._b({staticClass:"button-select-simple",attrs:{"items":_vm.items},model:{value:(_vm.modelWrapper),callback:function ($$v) {_vm.modelWrapper=$$v},expression:"modelWrapper"}},'ButtonSelect',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }